import { navItems, site, socialsContent } from "../content";
import { scrollToId, scrollToTop } from "../lib/scroll";

export const Footer = () => (
  <footer className="border-t border-black/10 bg-[#F7F7F5] pb-6 pt-20 md:pt-28" data-testid="site-footer">
    <div className="mx-auto max-w-7xl px-6">
      <div className="grid gap-12 rounded-[2rem] border border-black/10 bg-[#F2F2EF] p-8 md:grid-cols-12 md:p-12">
        <div className="md:col-span-5">
          <button type="button" onClick={scrollToTop} className="flex items-center gap-3 text-left" data-testid="footer-logo">
            <span className="grid h-9 w-9 place-items-center rounded-full border border-black/15 bg-white font-display text-xs font-extrabold text-[#1A1A1A]">
              LR
            </span>
            <span className="leading-tight">
              <span className="block font-display text-sm font-bold tracking-tight text-[#1A1A1A]">{site.name}</span>
              <span className="block font-mono text-[9px] uppercase tracking-[0.22em] text-black/50">{site.role}</span>
            </span>
          </button>
          <p className="mt-6 max-w-xs font-display text-2xl font-bold tracking-tight text-[#1A1A1A] md:text-3xl">
            Inteligência artificial traduzida em histórias.
          </p>
        </div>
        <div className="md:col-span-2">
          <p className="font-mono text-[10px] uppercase tracking-[0.22em] text-black/40">Navegar</p>
          <ul className="mt-4 space-y-2.5">
            {navItems.map((item) => (
              <li key={item.id}>
                <button
                  type="button"
                  data-testid={`footer-nav-${item.id}`}
                  onClick={() => scrollToId(item.id)}
                  className="text-sm text-black/70 transition-colors hover:text-[#1D4E89]"
                >
                  {item.label}
                </button>
              </li>
            ))}
          </ul>
        </div>
        <div className="md:col-span-2">
          <p className="font-mono text-[10px] uppercase tracking-[0.22em] text-black/40">Redes</p>
          <ul className="mt-4 space-y-2.5">
            {socialsContent.links.map((link) => (
              <li key={link.id}>
                <a
                  href={link.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid={`footer-social-${link.id}`}
                  aria-label={`${link.label} de Lucas Rocha (abre em nova aba)`}
                  className="text-sm text-black/70 transition-colors hover:text-[#1D4E89]"
                >
                  {link.label}
                </a>
              </li>
            ))}
          </ul>
        </div>
        <div className="md:col-span-3">
          <p className="font-mono text-[10px] uppercase tracking-[0.22em] text-black/40">Contato</p>
          <ul className="mt-4 space-y-2.5">
            <li>
              <a href={`mailto:${site.email}`} data-testid="footer-email" className="text-sm text-black/70 transition-colors hover:text-[#1D4E89]">
                {site.email}
              </a>
            </li>
            <li className="text-sm text-black/70">Projetos e parcerias</li>
          </ul>
        </div>
      </div>

      <div className="mt-14 select-none overflow-hidden md:mt-20" aria-hidden="true">
        <p className="whitespace-nowrap text-center font-display text-[13vw] font-black leading-[0.85] tracking-tighter text-[#1A1A1A] md:text-[11vw]">
          Lucas Rocha<span className="text-[#00E5FF]">.</span>
        </p>
      </div>

      <div className="mt-10 flex flex-wrap items-center justify-between gap-3 rounded-full border border-black/10 bg-white px-6 py-3 font-mono text-[10px] uppercase tracking-[0.16em] text-black/50">
        <span data-testid="footer-copyright">© 2026 Lucas Rocha · Publicitário</span>
        <span className="flex items-center gap-4">
          {socialsContent.links.map((link) => (
            <a
              key={link.id}
              href={link.url}
              target="_blank"
              rel="noopener noreferrer"
              aria-label={`${link.label} de Lucas Rocha (abre em nova aba)`}
              className="transition-colors hover:text-[#1D4E89]"
            >
              {link.label}
            </a>
          ))}
        </span>
      </div>
    </div>
  </footer>
);
